import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onAction }) => {
  const actions = [
    {
      id: 'add-vendor',
      label: 'Add Vendor',
      icon: 'UserPlus',
      description: 'Register a new vendor',
      color: 'bg-primary',
      action: () => onAction('add-vendor')
    },
    {
      id: 'record-expense',
      label: 'Record Expense',
      icon: 'Receipt',
      description: 'Log a new expense',
      color: 'bg-success',
      action: () => onAction('record-expense')
    },
    {
      id: 'setup-recurring-bill',
      label: 'Setup Recurring Bill',
      icon: 'RotateCcw',
      description: 'Configure automatic recurring vendor bill templates',
      color: 'bg-info',
      action: () => onAction('setup-recurring-bill')
    },
    {
      id: 'create-bill',
      label: 'Create Bill',
      icon: 'FileText',
      description: 'Create a new bill',
      color: 'bg-warning',
      action: () => onAction('create-bill')
    },
    {
      id: 'bulk-payment',
      label: 'Bulk Payment',
      icon: 'CreditCard',
      description: 'Process multiple payments',
      color: 'bg-accent',
      action: () => onAction('bulk-payment')
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {actions?.map((action) => (
        <button
          key={action?.id}
          onClick={action?.action}
          className="p-6 bg-card border border-border rounded-lg hover:shadow-elevated transition-all duration-200 text-left group"
        >
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 ${action?.color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-200`}>
              <Icon name={action?.icon} size={24} color="white" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                {action?.label}
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                {action?.description}
              </p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;